// extracted by mini-css-extract-plugin
export default {"mainContent":"QuickGame_mainContent__IX8D+","keyboard":"QuickGame_keyboard__Kxa4j"};